export {};
// export type Test1 = ProtoComponentDef<'pah' | 'ashpa', { pah: string, zevel: string, ashpa: string }>
// export type Test2 = SubProto<Test1, 'ashpa'>
// export type Test3 = SubProto<Test1, 'pah'>
// export type Test4 = SuperProto<Test2, Test3>
// const t: Test4 = {
// 	queryParamDef: {
// 		'pah': 'qd',
// 		'ashpa': 'asd',
// 		'zevel': 'asdas'
// 	},
// 	props: {
// 		queryParamsKeys: ['pah', 'ashpa']
// 	}
// };
//# sourceMappingURL=types.js.map